'use client';

import React, { type CSSProperties, type HTMLAttributes, type Ref } from 'react';
import styles from './Toast.module.css';

type ToastContainerProps = HTMLAttributes<HTMLDivElement> & {
  $margin: string;
  ref?: Ref<HTMLDivElement>;
};

export function ToastContainer({ $margin, style, ref, ...props }: ToastContainerProps) {
  const cssVars = {
    '--vapor-toast-container-margin': $margin,
  } as CSSProperties;

  return (
    <div
      ref={ref}
      className={styles.toastContainer}
      style={{ ...cssVars, ...style }}
      {...props}
    />
  );
}
